<div class="cowing-input-dropdown">
  <div *ngIf="label" class="cowing-input-label">
    {{ label | translate }}
  </div>
  <div class="cowing-input-dropdown-container">
    <div *ngIf="iconShow && iconName" class="cowing-input-text-icon">
      <img [src]="getIcon" alt="" />
    </div>
    <select
      *ngIf="!isForm"
      class="form-control"
      [ngClass]="['input-' + inputStyle, !iconShow ? 'not-padding' : '']"
      (change)="newValue($event.target.value)"
    >
      <option disabled>{{ "dropdown.choose-option" | translate }}</option>
      <option *ngFor="let option of options" [attr.data-content]="option">
        {{ type === "object" ? option.title || option.name : option }}
      </option>
    </select>
    <select
      dir="rtl"
      *ngIf="isForm"
      [formControl]="control"
      class="form-control"
      [ngClass]="[
        control.invalid && control.touched ? 'input-invalid' : '',
        'input-' + inputStyle,
        !iconShow ? 'not-padding' : ''
      ]"
      [compareWith]="compareFn"
    >
      <option disabled>{{ "dropdown.choose-option" | translate }}</option>
      <option *ngFor="let option of options" [ngValue]="option">
        {{ type === "object" ? option.title || option.name : option }}
      </option>
    </select>
  </div>
</div>
